<template>
  <v-row no-gutters>
    <div v-if="!page">
      Pick your base page
      <v-list>
        <v-list-item
          v-for="page in Object.values(pages).filter(p => p.section)"
          :key="page.id"
          @click="convertToNewFormat({ pageId: page.id, contextId: context.id })"
        >
          {{ page.title }} {{ page.section }}
        </v-list-item>
      </v-list>
    </div>
    <v-col v-else cols="12" :md="slimMode ? 12 : 8">
      <v-row>
        <content-header
          :title="page.title"
          :page="page"
          titlePlaceholder="Untitled Page"
          :description="page.description"
          descriptionPlaceholder="...add some general notes"
          @updateTitle="updatePageTitle({ pageId: page.id, title: $event })"
          @updateDescription="updatePageDescription({ pageId: page.id, description: $event })"
          @traverseOut="traverse({ ...$event, toIndex: 0 })"
        >
          <!-- <div style="">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon style="margin-top: 0px;">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="copyQuestions(false)">
                  <v-list-item-title>Copy Research Questions</v-list-item-title>
                </v-list-item>
                <v-list-item @click="copyQuestions(true)">
                  <v-list-item-title>Copy Questions & Notes</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="deletePage">
                  <v-list-item-title>Delete Page</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div> -->
        </content-header>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="page.isNewType">
          <context-doc
            ref="cardDoc"
            :pageId="page.id"
            :allowQuoteAttr="false"
            :selectedNoteBlocks="selectedNoteBlocks"
            @updateSelectedNotes="updateSelectedNotes"
            @updateSelectedNotesPage="selectedNotesPage = $event"
            @traverseLeaveUp="$refs.content.focusSummary($event)"
            @traverseLeaveDown="$emit('traverseOut', $event)"
            @pasteNoteBlocks="pasteNoteBlocks"
          >
          </context-doc>
        </v-col>
      </v-row>
    </v-col>
    <!-- <v-row no-gutters class="px-2 col-12 pb-4">
      <v-col class="shrink"> -->
    <!-- <v-btn-toggle v-model="viewMode" dense class="mr-1">
          <v-btn value="full" small>
            <v-icon>view_stream</v-icon>
          </v-btn>
          <v-btn value="grid" small>
            <v-icon>view_module</v-icon>
          </v-btn>
        </v-btn-toggle> -->
    <!-- <question-answer :question="page" :showText="true" class="mb-6"></question-answer> -->
    <!-- </v-col> -->
    <!-- <v-col class="shrink">
        <v-btn small ref="addCardBtn" text @click="addNewCard">Add Research Card</v-btn>
      </v-col> -->
    <!-- </v-row> -->

    <v-col
      v-if="
        viewMode == 'full' &&
          $vuetify.breakpoint.mdAndUp &&
          !slimMode
      "
      cols="3"
      class="pl-4"
      style="position: sticky; top: 0;"
    >
      <v-list dense color="transparent">
        <v-list-item class="px-0">
          <v-btn small text @click="">
            <v-icon class="mr-2">fiber_smart_record</v-icon> Capture Research Here
          </v-btn>
        </v-list-item>
        <v-list-item class="px-0">
          <v-btn
            text
            small
            class=""
            :color="page.important ? 'primary' : 'grey lighten-1'"
            @click="updatePageImportant({ pageId: page.id, value: !page.important })"
          >
            <template v-if="!page.important">
              <v-icon class="mr-2">bookmark_border</v-icon> Mark Important
            </template>
            <template v-if="page.important">
              <v-icon class="mr-2">bookmark</v-icon> Mark Unimportant
            </template>
          </v-btn>
        </v-list-item>
        <v-list-item class="px-0">
          <v-btn small text @click="toggleEmbeddedPages(true)">
            <v-icon class="mr-2">unfold_more</v-icon> Expand All
          </v-btn>
        </v-list-item>
        <v-list-item class="px-0" @click="toggleEmbeddedPages(false)">
          <v-btn small text> <v-icon class="mr-2">unfold_less</v-icon> Collapse All </v-btn>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list color="transparent" dense class="grey lighten-4">
        <v-list-item
          v-for="section in pageSections"
          :key="'toc-' + section.id"
          @click="
            $vuetify.goTo($refs.cardDoc.$refs[section.id][0], { container: '#notepage-container' })
          "
        >
          <v-list-item-content>
            <v-list-item-title>{{ section.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
    <!-- <v-col v-else :lg="viewMode == 'grid' ? '12' : '9'" class="row no-gutters">
      <v-col
        :cols="viewMode == 'full' ? 12 : 4"
        v-for="card in notesByCard"
        :key="card.id"
        :class="{ 'px-2': true, 'grid-card': viewMode == 'grid' }"
      >
        <note-card
          :ref="card.id"
          :card="card"
          :page="page"
          :key="card.id"
          :viewMode="viewMode"
          :selectedNoteBlocks="selectedNoteBlocks"
          @updateSelectedNotes="selectedNoteBlocks = $event"
          @deleteCard="deleteCard"
          @traverseOut="
            traverse({
              ...$event,
              toIndex: $event.direction == 'up' ? card.order - 1 : card.order + 1
            })
          "
        ></note-card>
      </v-col>
      <v-col cols="12">
        <v-btn text v-if="notesByCard.length" @click="addNewCard">Add Research Card</v-btn>
        <v-btn
          v-if="clipboard.contents.length"
          text
          color="orange darken-2"
          @click="pasteQuestions"
        >
          Paste Research Cards
        </v-btn>
      </v-col>
    </v-col> -->

    <v-col cols="12">
      <v-divider class="mt-6"></v-divider>
    </v-col>
    <span v-if="pages[selectedPageId]" class="caption">
      <template v-if="pages[selectedPageId].updated_at">
        Updated on {{ pages[selectedPageId].updated_at | formatDate }}
      </template>
      <template v-else> Created on {{ pages[selectedPageId].created_at | formatDate }} </template>
    </span>
  </v-row>
</template>

<script>
import DragSelect from '../DragSelect.vue';
import QuestionAnswer from '../../QuestionAnswer';
import NoteCard from './NoteCard';
import ContentHeader from '../ContentHeader';
import ContextDoc from '@/components/ContextDoc';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  components: {
    ContentHeader,
    QuestionAnswer,
    NoteCard,
    ContextDoc
  },
  props: {
    selectedNote: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      slowLoad: true,
      dragSelecting: false,
      selectedNoteRange: { start: false, end: false },
      selectedNotesPage: null,
      hiddenNoteBlocks: [],
      closedParents: [],
      viewMode: 'full' // full, card
    };
  },
  mounted() {
    //  turn off slowload after intial load
    const noteId = this.$route.query.card;

    setTimeout(() => {
      this.slowLoad = false;
      if (noteId) {
        console.log(noteId);
        this.$vuetify.goTo(this.$refs[noteId][0], {
          container: '#notepage-container',
          duration: 300
        });
      }
    }, 2000);
  },
  destroyed() {
    document.removeEventListener('keypress', this.copyTrigger);
  },
  computed: {
    ...mapState('views/context', [
      'selectedPageId',
      'focusTo',
      'showResourcePanel',
      'resourceViewer'
    ]),
    ...mapState('pages', ['pages']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['context', 'questions', 'userCanEdit']),
    ...mapGetters('pages', ['cardsByPage']),
    ...mapState('components/notepad', ['clipboard']),
    page() {
      console.log(this.selectedPageId);
      console.log(this.context.basePage);
      return this.selectedPageId
        ? this.pages[this.selectedPageId]
        : this.pages[this.context.basePage];
    },
    slimMode() {
      return this.resourceViewer.show && this.resourceViewer.width > 0;
    },
    pageSections() {
      if (!this.page) return [];
      const childrenNotes = Object.values(this.page.pageNotes)
        .filter(p => !p.toDelete && p.type == 'note' && p.content.html.slice(1, 3) == 'h1')
        .sort((a, b) => (a.order > b.order ? 1 : -1));

      return childrenNotes.map(n => {
        const text = n.content.html.slice(4, n.content.html.length - 5);
        return { type: 'header', text, id: n.id };
      });
    },
    notesByCard() {
      return this.cardsByPage[this.selectedPageId];
    },
    selectedNoteBlocks() {
      console.log('range', this.selectedNoteRange);
      if (this.selectedNoteRange.start && this.selectedNoteRange.end) {
        console.log(this.selectedNoteRange)
        const rangeIds = Object.values(this.selectedNoteRange); //
        const page = this.pages[this.selectedNotesPage];
        if (!page) {
          console.log('no page!');
          return [];
        }
        const rangeDocs = rangeIds
          .map(id => page.pageNotes[id])
          .sort((a, b) => (a.order < b.order ? -1 : 1));
          console.log(rangeDocs);
        
        if (!rangeDocs[0] || !rangeDocs[1]) return [];
        const startOrder = rangeDocs[0].order;
        const endOrder = rangeDocs[1].order;
        const noteIds = Object.values(page.pageNotes)
          .filter(p => !p.toDelete && p.order >= startOrder && p.order <= endOrder)
          .sort((a, b) => (a.order < b.order ? -1 : 1))
          .map(n => n.id);
        console.log(noteIds);
        return noteIds;
      } else {
        console.log('no note blocks selected');
        return [];
      }
    }
  },
  watch: {
    $route: function(n, o) {
      if (n.query.card && n.query.card != o.query.card && this.$refs[n.query.card]) {
        if (n.params.page == o.params.page) {
          this.$vuetify.goTo(this.$refs[n.query.card][0], {
            container: '#notepage-container',
            duration: 300
          });
        } else {
          this.$nextTick(() => {
            this.$vuetify.goTo(this.$refs[n.query.card][0], {
              container: '#notepage-container',
              duration: 300
            });
          });
        }
      }
    },
    selectedPageId: function() {
      //  Reset selectedNoteBlocks
      this.selectedNoteRange = { start: false, end: false };
      //  Give us a second to load everything slowly, after that load new things load instanlty
      this.slowLoad = true;
      setTimeout(() => (this.slowLoad = false), 2000);
    },
    selectedNoteBlocks: function(newValue, oldValue) {
      console.log('selectedBlocks', newValue);
      if (newValue.length > 0 && oldValue.length == 0) {
        //  we started drag
        console.log('add copy event listener');
        document.addEventListener('keydown', this.selectBlockHotKeys);
      } else if (newValue.length == 0 && oldValue.length > 0) {
        console.log('remove copy event listener');
        document.removeEventListener('keydown', this.selectBlockHotKeys);
      }
    }
  },
  methods: {
    ...mapActions('pages', [
      'removeCard',
      'addCard',
      'addCardNote',
      'updatePageTitle',
      'updatePageDescription',
      'removePage',
      'removeNote',
      'duplicateNotes',
      'updatePageImportant'
    ]),
    ...mapActions('context', ['convertToNewFormat']),
    ...mapMutations('components/magicClipboard', ['setClipboard']),
    ...mapMutations('views/context', ['setSelectedPageId']),
    log(x) {
      console.log(x);
    },
    toggleEmbeddedPages(v) {
      this.$refs.cardDoc.toggleEmbeddedPages(v);
    },
    updateSelectedNotes({ start, end }) {
      console.log('update notes', start, end);
      if (start) {
        this.$set(this.selectedNoteRange, 'start', start);
      }
      if (end) {
        this.$set(this.selectedNoteRange, 'end', end);
      }
    },
    selectBlockHotKeys(event) {
      const key = event.which || event.keyCode;
      console.log(event);
      if (key == 67 && event.ctrlKey) {
        this.copyBlocks();
      }
      if (key == 46 || key == 8) {
        //  handle delete
        this.deleteSelectedBlocks();
      }
    },
    deleteSelectedBlocks() {
      console.log(this.selectedNoteBlocks);
      const blockIds = [...this.selectedNoteBlocks];
      const pageId = this.selectedNotesPage;

      console.log('pageId', pageId);
      blockIds.forEach(b => {
        this.removeNote({ noteId: b, pageId });
      });
      this.updateSelectedNotes({ start: false, end: false });
      this.selectedNotesPage = null;
    },
    copyBlocks() {
      console.log('copy blocks note page');
      const blockIds = this.selectedNoteBlocks;
      console.log(this.selectedNoteBlocks);
      const page = this.pages[this.selectedNotesPage];
      let text = '';
      let contents = [];
      console.log('blockIds page', page);
      let blocks = blockIds.map(id => page.pageNotes[id]);

      blocks = blocks.sort((a, b) => a.order - b.order);
      blocks.forEach(b => {
        try {
          // const docRef = this.$refs['cardDoc'];
          // console.log(docRef);
          // const noteRef = docRef.$refs[b.id][0];
          if (b.type == 'note') {
            text += b.content.html;
          } else if (b.type == 'card') {
            text += this.pages[b.pageId].title;
          }
          console.log(text);
        } catch (e) {
          console.log(e);
        }
        //text += this.$refs[b.id][0].$refs.editor.editor.getText();
        contents.push(b.id);
      });
      this.setClipboard({
        text,
        type: 'block',
        blockData: {
          blockIds,
          contents,
          parent: this.selectedNotesPage
        }
      });
      this.$copyText(text);
    },
    // copyQuestions(copyContent) {
    //   console.log('copy blocks notePage');
    //   const cards = this.notesByCard;
    //   const notes = this.page.pageNotes.filter(n => !n.toDelete);

    //   let text = '';
    //   //blocks = blocks.sort((a, b) => a.order - b.order);
    //   this.setClipboard({
    //     text,
    //     cards,
    //     notes,
    //     parent: this.selectedPageId
    //   });
    //   this.$copyText(text);
    // },
    // toggleSelection(note) {
    //   //  check if the note we entered is already selected
    //   console.log(note.id);
    //   const selected = this.selectedNoteBlocks.includes(note.id);
    //   if (selected) {
    //     console.log('remove ', note.order);
    //     //  Already selected, we are going back and should deselect the previous one
    //     if (this.selectedNoteBlocks[this.selectedNoteBlocks.length - 1] != note.id) {
    //       this.selectedNoteBlocks.pop();
    //     }
    //   } else {
    //     console.log('add ', note.order);
    //     //  Add this one to selected
    //     this.selectedNoteBlocks.push(note.id);
    //   }
    // },
    clearDragSelection() {
      this.selectedNoteRange = { start: false, end: false };
    },
    async addNewCard() {
      const newId = await this.addCard({
        pageId: this.selectedPageId
      });
      this.$nextTick(() => {
        this.$refs[newId][0].focusTitle();
      });
    },
    deleteCard({ cardId }) {
      // if (this.notesByCard.length > 1) {
      this.removeCard({ cardId: cardId, pageId: this.selectedPageId });
      // }
    },
    traverse({ toIndex, direction = 'up', event }) {
      console.log(toIndex, direction, event);
      try {
        let targetRef = false;
        const bound = event && event.bounds ? event.bounds.left : 0;
        if (toIndex == -1) {
          //  go up to the question title
          targetRef = this.$refs.header;
          targetRef.$refs.descriptionEditor.setCaret({
            prevLeft: bound,
            direction: direction
          });
        } else {
          //  get next element in list
          //const target = this.selectedPageNotes.find(n => n.order == toIndex);
          const target = this.notesByCard[toIndex];
          targetRef = target ? this.$refs[target.id][0] : false;
          if (targetRef) {
            targetRef.traverseInto({ direction, event });
          } else {
            if (!this.notesByCard.length) this.$refs.addCardBtn.$el.focus();
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    deletePage() {
      this.removePage({ pageId: this.page.id });
      this.setSelectedPageId(null);
    },
    // toggleAll(show) {
    //   this.notesByCard.map(note => {
    //     this.$refs[note.id][0].showChildren = show;
    //   });
    // },
    pasteNoteBlocks(order) {
      console.log('paste');
      console.log(this.clipboard);
      return;
    }
    // setupDrag({ event, ids, element, shift }) {
    //   // get the element and shift positions for dragHelper
    //   let html = '';
    //   //  Build the html drag element
    //   let allIds = ids;
    //   if (this.selectedNoteBlocks && this.selectedNoteBlocks.includes(ids[0])) {
    //     //  Drag all the selected note blocks
    //     allIds = this.selectedNoteBlocks;
    //   }
    //   allIds.forEach(i => {
    //     html += this.$refs[i][0].$el.innerHTML;
    //   });

    //   // update drag data
    //   const dragObject = {
    //     element,
    //     shift,
    //     html,
    //     ids: allIds,
    //     types: ['noteBlock'],
    //     parent: {
    //       id: this.selectedPageId,
    //       type: 'page'
    //     }
    //   };
    //   //  first set initial drag position
    //   const { x, y } = event;
    //   this.setDragPosition({ x, y });

    //   //  now set drag content
    //   this.updateDraggedData(dragObject);
    // }
  }
};
</script>

<style>
.prompt-btn,
.prompt-btn .v-btn__content {
  justify-content: left !important;
}

@media (min-width: 1264px) {
  .notepad-sizer {
    max-width: 600px !important;
    width: 600px !important;
  }
}

@media (min-width: 1904px) {
  .notepad-sizer {
    max-width: 700px !important;
    width: 700px !important;
  }
}

.grid-card {
  max-width: 340px;
  min-width: 300px;
}
</style>
